(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function norm(v) {
    if (v == null || v === false) return '';
    return String(v).trim();
  }

  function readExtrasScript(variantSelects) {
    const el = variantSelects.querySelector('script[type="application/json"][data-bd-variant-extras]');
    if (!el || !el.textContent.trim()) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  function collectSelection(variantSelects) {
    const map = {};
    variantSelects.querySelectorAll('fieldset.js input[type="radio"]:checked').forEach((input) => {
      const pos = input.dataset.optionPosition;
      if (pos) map[pos] = input.value;
    });
    variantSelects.querySelectorAll('select[data-option-position]').forEach((select) => {
      const pos = select.dataset.optionPosition;
      if (pos) map[pos] = select.value;
    });
    return map;
  }

  function findVariantRow(extras, selection) {
    if (!extras || !Array.isArray(extras)) return null;
    return (
      extras.find((row) => {
        return (
          norm(row.o1) === norm(selection['1']) &&
          norm(row.o2) === norm(selection['2']) &&
          norm(row.o3) === norm(selection['3'])
        );
      }) || null
    );
  }

  function refresh(variantSelects) {
    if (!variantSelects) return;
    const extras = readExtrasScript(variantSelects);
    if (!extras) return;

    const fieldset = variantSelects.querySelector('fieldset.product-form__input--bd-variant-cards');
    if (!fieldset) return;

    const cardPos = fieldset.dataset.bdCardsOptionPosition;
    if (!cardPos) return;

    const baseSelection = collectSelection(variantSelects);

    fieldset.querySelectorAll('.bd-variant-cards__item').forEach((item) => {
      const input = item.querySelector('input.bd-variant-cards__input');
      if (!input) return;

      const selection = { ...baseSelection, [cardPos]: input.value };
      const row = findVariantRow(extras, selection);

      const perDay = item.querySelector('.bd-variant-cards__perday');
      let badge = item.querySelector('.bd-variant-cards__badge');
      const label = item.querySelector('.bd-variant-cards__label');
      const meta = item.querySelector('.bd-variant-cards__meta');
      const perStr = row && row.perDay != null ? String(row.perDay) : '';
      const badgeStr = row && row.badge != null ? String(row.badge) : '';
      const badgeTrim = badgeStr.trim();

      if (perDay) perDay.textContent = perStr;

      if (badgeTrim) {
        if (!badge && label && meta) {
          badge = document.createElement('span');
          badge.className = 'bd-variant-cards__badge';
          label.insertBefore(badge, meta);
        }
        if (badge) badge.textContent = badgeTrim;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function onOptionChange(msg) {
    const event = msg && msg.data && msg.data.event;
    const target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;
    const vs = target.closest('variant-selects');
    if (!vs) return;
    refresh(vs);
  }

  function onVariantChange(msg) {
    const sectionId = msg && msg.data && msg.data.sectionId;
    if (!sectionId) return;
    const vs = document.querySelector(`variant-selects#variant-selects-${sectionId}`);
    refresh(vs);
  }

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, onOptionChange);
  subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);

  function refreshAll() {
    document.querySelectorAll('variant-selects script[data-bd-variant-extras]').forEach((script) => {
      const vs = script.closest('variant-selects');
      if (vs) refresh(vs);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
